exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.action-link[data-v-6634dab3] {\n  cursor: pointer;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
